import React from "react";

// A 12×12 times-table mastery heatmap, like the one in the parent dashboard.
// Deterministic pattern: low tables secure, 7s/8s/12s still wobbly.
const COLORS = { secure: "#1F8A5B", good: "#7CC59F", wobbly: "#FFC34D", new: "rgba(23,26,54,0.08)" };

function level(r, c) {
  const hard = [7, 8, 12];
  if (r <= 5 && c <= 5) return "secure";
  if (r === 10 || c === 10 || r === 2 || c === 2 || r === 1 || c === 1) return "secure";
  if (hard.includes(r) && hard.includes(c)) return "new";
  if (hard.includes(r) || hard.includes(c)) return (r * c) % 3 === 0 ? "good" : "wobbly";
  if (r === 11 || c === 11) return (r + c) % 4 === 0 ? "wobbly" : "good";
  return (r * 7 + c) % 5 === 0 ? "wobbly" : "good";
}

export default function TTGrid() {
  const cells = [];
  for (let r = 1; r <= 12; r++) {
    for (let c = 1; c <= 12; c++) {
      cells.push(<i key={`${r}-${c}`} style={{ "--c": COLORS[level(r, c)] }} />);
    }
  }
  return (
    <div className="ttgrid" role="img" aria-label="Times tables mastery grid">
      {cells}
    </div>
  );
}

export { COLORS };
